import { render, staticRenderFns } from "./Orders.vue?vue&type=template&id=47bc3cac&"
import script from "./Orders.js?vue&type=script&lang=js&"
export * from "./Orders.js?vue&type=script&lang=js&"
import style0 from "./Orders.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports